import { TrendDelta } from '../../util/evaluationFormat';

const signed = (value: number, text: string) => `${value < 0 ? '−' : '+'}${text}`;

const swedishNumber = (value: number) => String(Math.abs(value)).replace('.', ',');

export const formatTrendLabel = ({ delta, percent }: TrendDelta): string =>
  `${signed(delta, Math.abs(delta).toFixed(1).replace('.', ','))} (${signed(percent, swedishNumber(percent))} %)`;

const STOCKHOLM_DAY = new Intl.DateTimeFormat('sv-SE', {
  timeZone: 'Europe/Stockholm',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

export const formatStockholmDay = (instant: string): string => STOCKHOLM_DAY.format(new Date(instant));

export const formatDayKey = (dayKey: string, locale: string): string =>
  new Intl.DateTimeFormat(locale, { timeZone: 'UTC', year: 'numeric', month: 'long', day: 'numeric' }).format(
    new Date(`${dayKey}T00:00:00.000Z`),
  );
